Promise.allSeries = promises => Promise.allLimit(1, promises);
